import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SelfieCapture from "./SelfieCapture";
import ConfirmPhoto from "./ConfirmPhoto";
import IdCapture from "./IdCapture";
import SubmitPage from "./SubmitPage";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/selfie" />} />
        <Route path="/:token" element={<Navigate to="/:token/selfie" />} />
        <Route path="/:token/selfie" element={<SelfieCapture />} />
        <Route
          path="/:token/selfie-confirm"
          element={<ConfirmPhoto type="selfie" />}
        />
        <Route path="/:token/id-front" element={<IdCapture side="front" />} />
        <Route
          path="/:token/id-front-confirm"
          element={<ConfirmPhoto type="id-front" />}
        />
        <Route path="/:token/id-back" element={<IdCapture side="back" />} />
        <Route
          path="/:token/id-back-confirm"
          element={<ConfirmPhoto type="id-back" />}
        />
        <Route path="/:token/submit" element={<SubmitPage />} />
      </Routes>
    </Router>
  );
}

export default App;
